/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewHoneypot } from './CRSFSecReviewHoneypot';
import {
    CRSFSecReviewHoneypotFromJSON,
    CRSFSecReviewHoneypotFromJSONTyped,
    CRSFSecReviewHoneypotToJSON,
} from './CRSFSecReviewHoneypot';

/**
 * 
 * @export
 * @interface CRSFSecReviewHoneypotsAggregate
 */
export interface CRSFSecReviewHoneypotsAggregate {
    /**
     * 
     * @type {Array<CRSFSecReviewHoneypot>}
     * @memberof CRSFSecReviewHoneypotsAggregate
     */
    malicious: Array<CRSFSecReviewHoneypot>;
    /**
     * 
     * @type {Array<CRSFSecReviewHoneypot>}
     * @memberof CRSFSecReviewHoneypotsAggregate
     */
    other: Array<CRSFSecReviewHoneypot>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewHoneypotsAggregate
     */
    total: number;
}

/**
 * Check if a given object implements the CRSFSecReviewHoneypotsAggregate interface.
 */
export function instanceOfCRSFSecReviewHoneypotsAggregate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "malicious" in value;
    isInstance = isInstance && "other" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFSecReviewHoneypotsAggregateFromJSON(json: any): CRSFSecReviewHoneypotsAggregate {
    return CRSFSecReviewHoneypotsAggregateFromJSONTyped(json, false);
}

export function CRSFSecReviewHoneypotsAggregateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewHoneypotsAggregate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'malicious': ((json['malicious'] as Array<any>).map(CRSFSecReviewHoneypotFromJSON)),
        'other': ((json['other'] as Array<any>).map(CRSFSecReviewHoneypotFromJSON)),
        'total': json['total'],
    };
}

export function CRSFSecReviewHoneypotsAggregateToJSON(value?: CRSFSecReviewHoneypotsAggregate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'malicious': ((value.malicious as Array<any>).map(CRSFSecReviewHoneypotToJSON)),
        'other': ((value.other as Array<any>).map(CRSFSecReviewHoneypotToJSON)),
        'total': value.total,
    };
}

